import { legendStrokeColors } from 'utils/variables';

export const padding = {
  left: 4,
  top: 4,
};

export const color = {
  colorLightTheme: legendStrokeColors.DARK,
  colorDarkTheme: legendStrokeColors.LIGHT,
};

export const lineWidth = 1;

export const minRadius = 5;
export const midRadius = 12;
export const maxRadius = 19;
export const radii = [minRadius, midRadius, maxRadius];

export const gap = 8;
